import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faIdCard, faCreditCard, faFileAlt, faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import Alerts from '../../molecules/Alerts';
import { v4 as UUID } from 'uuid';
import { useModalCleanup } from "../../../utils/useModalCleanup";
import './WelcomePage.css';

const steps = [
  { icon: faIdCard,         label: 'Account Information', desc: 'Company and contact details' },
  { icon: faCreditCard,     label: 'Bank Details',        desc: 'Bank type and payment info' },
  { icon: faFileAlt,        label: 'Files',               desc: 'Upload supporting documents' },
  { icon: faClipboardCheck, label: 'Review & Submit',     desc: 'Confirm and submit the form' },
];

const WelcomePage = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [alerts, setAlerts] = useState([]);
  const modalCleanup = useModalCleanup();

  const handleStart = () => {
    try {
      navigate(`/${token}/account`);
    } catch (error) {
      addAlert('Error starting registration. Please try again. ' + error, 'error');
    }
  };

  const addAlert = (message, color, timeout = 7000) => {
    const id = UUID();
    setAlerts(prev => [...prev, { message, id, color, timeout }]);
  };

  return (
    <Container>
      <Alerts alerts={alerts} setAlerts={setAlerts} />
      <div className="wlc-wrap">
        <div className="wlc-hero">
          <h1 className="wlc-hero__title">Hafnia Vendor Form</h1>
          <p className="wlc-hero__sub">Complete the following steps to register as a vendor with Hafnia.</p>
        </div>

        <div className="wlc-steps">
          {steps.map((step, i) => (
            <div className="wlc-step" key={i}>
              <div className="wlc-step__num">{i + 1}</div>
              <div className="wlc-step__icon">
                <FontAwesomeIcon icon={step.icon} />
              </div>
              <div className="wlc-step__label">{step.label}</div>
              <div className="wlc-step__desc">{step.desc}</div>
            </div>
          ))}
        </div>

        <p className="wlc-note">
          All information must be accurate and complete. You can navigate freely between steps before submitting.
        </p>

        <div className="wlc-cta">
          <Button className="wlc-btn" onClick={handleStart}>
            Start Registration
            <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default WelcomePage;
